export const validateAccountForm = (formData) => {
  const errors = {};

  Object.keys(formData).forEach(key => {
    if (!formData[key] && key !== "email_cc") {
      errors[key] = "Campo obrigatório";
    }
  });

  const emailRegex = /\S+@\S+\.\S+/;
  if (formData.email && !emailRegex.test(formData.email)) {
    errors.email = "E-mail inválido";
  }

  return errors;
};
